export const getTranslateYAnimation = (translateAnimation: boolean) => {
  return ` opacity-0 duration-700 ease-in-out  ${
    translateAnimation ? "translate-y-0 opacity-100" : "translate-y-12"
  }`;
};
